// src/utils/electricalUtils.js

// --- BASE DE DATOS NORMATIVA RIC N°04 (CHILE) ---
export const RIC4_DATA = {
    "70C_FIJO": {
        label: "Fijo 70°C (H07V, THWN, NYIFY)",
        methods: {
            "A1": { description: "A1 - Ducto embutido en pared aislante", data: [{s:1.5,a:13.5},{s:2.5,a:18},{s:4,a:24},{s:6,a:31},{s:10,a:42},{s:16,a:56},{s:25,a:73},{s:35,a:89},{s:50,a:108},{s:70,a:136},{s:95,a:164},{s:120,a:188},{s:150,a:215},{s:185,a:243},{s:240,a:285},{s:300,a:324}] },
            "B1": { description: "B1 - Ducto sobre pared", data: [{s:1.5,a:15.5},{s:2.5,a:21},{s:4,a:28},{s:6,a:36},{s:10,a:50},{s:16,a:68},{s:25,a:89},{s:35,a:110},{s:50,a:134},{s:70,a:171},{s:95,a:207},{s:120,a:239},{s:150,a:274},{s:185,a:311},{s:240,a:365},{s:300,a:415}] },
            "E": { description: "E - Aire libre / Bandeja", data: [{s:1.5,a:18.5},{s:2.5,a:25},{s:4,a:34},{s:6,a:43},{s:10,a:60},{s:16,a:80},{s:25,a:106},{s:35,a:131},{s:50,a:159},{s:70,a:202},{s:95,a:245},{s:120,a:285},{s:150,a:330},{s:185,a:375},{s:240,a:445},{s:300,a:510}] }
        }
    },
    "90C_FIJO": {
        label: "Fijo 90°C (RV-K, RZ1, THHN)",
        methods: {
            "A1": { description: "A1 - Ducto pared aislante", data: [{s:1.5,a:17},{s:2.5,a:23},{s:4,a:31},{s:6,a:40},{s:10,a:54},{s:16,a:73},{s:25,a:95},{s:35,a:117},{s:50,a:141},{s:70,a:179},{s:95,a:216},{s:120,a:249},{s:150,a:284},{s:185,a:322},{s:240,a:376},{s:300,a:429}] },
            "B1": { description: "B1 - Ducto sobre pared", data: [{s:1.5,a:20},{s:2.5,a:27},{s:4,a:37},{s:6,a:48},{s:10,a:66},{s:16,a:88},{s:25,a:117},{s:35,a:144},{s:50,a:175},{s:70,a:222},{s:95,a:269},{s:120,a:312},{s:150,a:358},{s:185,a:408},{s:240,a:481},{s:300,a:551}] },
            "D1": { description: "D1 - Enterrado ducto", data: [{s:1.5,a:26},{s:2.5,a:34},{s:4,a:44},{s:6,a:56},{s:10,a:75},{s:16,a:98},{s:25,a:128},{s:35,a:157},{s:50,a:186},{s:70,a:227},{s:95,a:275},{s:120,a:315},{s:150,a:355},{s:185,a:400},{s:240,a:465},{s:300,a:520}] },
            "D2": { description: "D2 - Enterrado directo", data: [{s:1.5,a:27},{s:2.5,a:36},{s:4,a:47},{s:6,a:59},{s:10,a:79},{s:16,a:103},{s:25,a:135},{s:35,a:164},{s:50,a:195},{s:70,a:238},{s:95,a:286},{s:120,a:328},{s:150,a:370},{s:185,a:417},{s:240,a:485},{s:300,a:545}] },
            "E": { description: "E - Bandeja/Aire", data: [{s:1.5,a:23},{s:2.5,a:32},{s:4,a:42},{s:6,a:54},{s:10,a:75},{s:16,a:100},{s:25,a:127},{s:35,a:158},{s:50,a:192},{s:70,a:246},{s:95,a:298},{s:120,a:346},{s:150,a:395},{s:185,a:450},{s:240,a:530},{s:300,a:600}] },
            "F": { description: "F - Unipolares contacto", data: [{s:1.5,a:25},{s:2.5,a:34},{s:4,a:46},{s:6,a:60},{s:10,a:84},{s:16,a:112},{s:25,a:148},{s:35,a:180},{s:50,a:225},{s:70,a:289},{s:95,a:352},{s:120,a:410},{s:150,a:470},{s:185,a:540},{s:240,a:640},{s:300,a:725}] }
        }
    },
    "MOVIL": { label: "Uso Móvil", methods: { "E": { description: "E - Aire libre", data: [{s:0.75,a:6},{s:1,a:10},{s:1.5,a:16},{s:2.5,a:25},{s:4,a:32},{s:6,a:40},{s:10,a:55},{s:16,a:75},{s:25,a:98},{s:35,a:125}] } } },
    "DESNUDO": { label: "Cobre Desnudo", methods: { "AEREO": { description: "Aéreo / Aisladores", data: [{s:10,a:80},{s:16,a:105},{s:25,a:140},{s:35,a:175},{s:50,a:215},{s:70,a:275},{s:95,a:340},{s:120,a:395}] } } }
};

export const RHO = { cobre: 0.018, aluminio: 0.028 };

export const CONDUIT_FILL_DATA = {
    conduit: { '16':132, '20':227, '25':346, '32':615, '40':907, '50':1520 },
    cable: { '1.5':7.1, '2.5':10.2, '4.0':13.9, '6.0':18.1, '10.0':28.3 }
};

export const electricalUtils = {
    // 1. Ley de Ohm
    calcOhmsLaw: ({ v, i, r, p }) => {
        const V=v?parseFloat(v):null; const I=i?parseFloat(i):null; const R=r?parseFloat(r):null; const P=p?parseFloat(p):null;
        const inputs=[V,I,R,P].filter(val=>val!==null);
        if(inputs.length<2) return { error: 'Se requieren 2 valores' };
        if(inputs.length>2) return { error: 'Ingrese solo 2 valores' };
        let nV=V,nI=I,nR=R,nP=P;
        if(V!=null&&I!=null){nR=V/I;nP=V*I}else if(V!=null&&R!=null){nI=V/R;nP=(V*V)/R}else if(V!=null&&P!=null){nI=P/V;nR=(V*V)/P}else if(I!=null&&R!=null){nV=I*R;nP=(I*I)*R}else if(I!=null&&P!=null){nV=P/I;nR=P/(I*I)}else if(R!=null&&P!=null){nV=Math.sqrt(P*R);nI=Math.sqrt(P/R)}
        return { v:nV.toFixed(2), i:nI.toFixed(2), r:nR.toFixed(2), p:nP.toFixed(2) };
    },

    // 2. Potencia
    calcPower: ({ phases, voltage, current, pf }) => {
        const V = parseFloat(voltage), I = parseFloat(current), PF = parseFloat(pf);
        if (isNaN(V) || isNaN(I) || isNaN(PF)) return null;
        let s = phases === '1' ? (V * I) / 1000 : (Math.sqrt(3) * V * I) / 1000;
        const p = s * PF;
        const q = Math.sqrt(Math.pow(s, 2) - Math.pow(p, 2));
        return { p: p.toFixed(2), s: s.toFixed(2), q: q.toFixed(2) };
    },

    // 3. Conductor
    calcConductor: ({ system, cableType, method, inputMode, power, current, voltage, distance, drop, pf }) => {
        let P_watts = parseFloat(power) * 1000;
        let I_nominal = parseFloat(current) || 0;
        const V = parseFloat(voltage), L = parseFloat(distance), MAX_DROP = parseFloat(drop), FP = parseFloat(pf);

        if (V <= 0 || L <= 0 || MAX_DROP <= 0 || FP <= 0) return { error: 'Valores inválidos.' };
        const sqrt3 = Math.sqrt(3);

        if (inputMode === 'power') {
            if (system === 'monofasico') I_nominal = P_watts / (V * FP); else I_nominal = P_watts / (sqrt3 * V * FP);
        }

        const selectedCableData = RIC4_DATA[cableType];
        if (!selectedCableData || !selectedCableData.methods[method]) return { error: 'Método no válido.' };

        const table = selectedCableData.methods[method].data;
        const methodDesc = selectedCableData.methods[method].description;
        const rowAmpacity = table.find(r => r.a >= I_nominal);
        const sectionByAmpacity = rowAmpacity ? rowAmpacity.s : table[table.length - 1].s;
        const ampacityMax = rowAmpacity ? rowAmpacity.a : table[table.length - 1].a;
        const exceedsTable = I_nominal > ampacityMax;

        const materialRho = RHO.cobre; 
        const K = system === 'monofasico' ? 2 : sqrt3;
        const deltaV_max = V * (MAX_DROP / 100);
        const sectionByDrop = (K * L * I_nominal * materialRho) / deltaV_max;
        
        const sectionFinal = Math.max(sectionByAmpacity, sectionByDrop);
        const finalRow = table.find(r => r.s >= sectionFinal) || table[table.length - 1];
        const commercialSection = finalRow.s;

        const deltaV_real = (K * L * I_nominal * materialRho) / commercialSection;
        const drop_real_percent = (deltaV_real / V) * 100;
        
        return { 
            currentNominal: I_nominal.toFixed(1),
            sectionDrop: sectionByDrop.toFixed(4),
            sectionAmpacity: sectionByAmpacity.toFixed(2),
            commercial: commercialSection,
            deltaVReal: deltaV_real.toFixed(2),
            dropRealPercent: drop_real_percent.toFixed(2),
            tableInfo: methodDesc,
            exceedsTable,
            error: null
        };
    },

    // 4. Cortocircuito
    calcShortCircuit: ({ system, voltage, kva, z, l, s, mat, t_fault, k_factor }) => {
        const V = parseFloat(voltage); 
        const S_kVA = parseFloat(kva);
        const Z_percent = parseFloat(z);
        const L_m = parseFloat(l);
        const S_mm2 = parseFloat(s);

        if (!V || !S_kVA || !Z_percent || !L_m || !S_mm2) return null;

        let I_cc_tr, V_LN, Z_tr, Z_cable, Z_total, I_cc_load;

        if (system === '3') {
            const I_n_tr = (S_kVA * 1000) / (Math.sqrt(3) * V);
            I_cc_tr = I_n_tr / (Z_percent / 100);
            V_LN = V / Math.sqrt(3);
            Z_tr = (V_LN / I_cc_tr) * 1000; 
            
            // Estimación típica para transformadores R/X ratio (R ~ 30%Z, X ~ 95%Z)
            const R_tr = 0.3 * Z_tr;
            const X_tr = 0.95 * Z_tr;
            
            const rho = mat === 'Cu' ? 0.018 : 0.028;
            const R_cable = (rho * L_m / S_mm2) * 1000; 
            const X_cable = 0.08 * L_m; 
            Z_cable = Math.sqrt(R_cable**2 + X_cable**2);
            
            const R_total = R_tr + R_cable;
            const X_total = X_tr + X_cable;
            Z_total = Math.sqrt(R_total**2 + X_total**2);
            
            I_cc_load = (V_LN / (Z_total / 1000));
        } else {
            const I_n_tr = (S_kVA * 1000) / V;
            I_cc_tr = I_n_tr / (Z_percent / 100);
            V_LN = V; 
            Z_tr = (V / I_cc_tr) * 1000; 
            
            const R_tr = 0.3 * Z_tr;
            const X_tr = 0.95 * Z_tr;
            
            const rho = mat === 'Cu' ? 0.018 : 0.028;
            const R_cable = 2 * (rho * L_m / S_mm2) * 1000; 
            const X_cable = 2 * 0.08 * L_m;
            Z_cable = Math.sqrt(R_cable**2 + X_cable**2);
            
            const R_total = R_tr + R_cable;
            const X_total = X_tr + X_cable;
            Z_total = Math.sqrt(R_total**2 + X_total**2);
            
            I_cc_load = (V / (Z_total / 1000));
        }

        const I_cc_load_amps = I_cc_load; 
        const S_earth = (Math.sqrt(Math.pow(I_cc_load_amps, 2) * t_fault)) / k_factor;

        return {
            icc_tr: (I_cc_tr / 1000).toFixed(1), 
            icc_load: (I_cc_load / 1000).toFixed(2),
            z_total: Z_total.toFixed(1),
            z_tr: Z_tr.toFixed(1),
            z_cable: Z_cable.toFixed(1),
            earth_section: S_earth.toFixed(2)
        };
    },

    // 5. Factor Potencia
    calcPowerFactor: ({ power, currentPf, targetPf, loadType, steps }) => {
        const P = parseFloat(power);
        const PF1 = parseFloat(currentPf);
        const PF2 = parseFloat(targetPf);

        if (!P || !PF1 || !PF2 || PF1 <= 0 || PF1 >= 1 || PF2 <= 0 || PF2 > 1) {
            return { error: 'Datos inválidos. FP debe estar entre 0 y 1.' };
        }

        const phi1 = Math.acos(PF1);
        const phi2 = Math.acos(PF2);

        let Q1 = P * Math.tan(phi1);
        if (loadType === 'capacitive') Q1 = -Q1;

        const Q2 = P * Math.tan(phi2);
        const Qc_total = Q1 - Q2;
        const equipmentType = Qc_total > 0 ? 'Banco de Condensadores' : 'Reactores Inductivos';
        const compensationValue = Math.abs(Qc_total);

        const numSteps = parseInt(steps);
        const stepValue = compensationValue / numSteps;
        const stepsArray = Array(numSteps).fill(stepValue);
        const maxVal = Math.max(P, Math.abs(Q1), Math.abs(Q2), Math.abs(Qc_total));
        const scale = 180 / maxVal;

        return {
            kvar: compensationValue.toFixed(2),
            type: equipmentType,
            q1: Q1, q2: Q2, qc: Qc_total,
            steps: stepsArray,
            scale: scale,
            phi1: loadType === 'inductive' ? phi1 : -phi1,
            phi2: phi2,
            error: null
        };
    },

    // 6. Motores
    calcMotor: ({ u, p, v, ph, eff, pf }) => {
        let Pw = parseFloat(p);
        if(u === 'hp') Pw *= 745.7; else Pw *= 1000;
        const V = parseFloat(v);
        const PF = parseFloat(pf);
        const EFF = parseFloat(eff);
        let I = 0;
        if(ph === '1') I = Pw / (V * PF * EFF);
        else I = Pw / (Math.sqrt(3) * V * PF * EFF);
        return I.toFixed(2);
    },

    // 7. Relé Térmico
    calcThermalRelay: ({ u, p, v, ph, sf }) => {
        const EFF = 0.85, PF = 0.85;
        let Pw = parseFloat(p);
        if(u === 'hp') Pw *= 745.7; else Pw *= 1000;
        const V = parseFloat(v);
        let In = 0;
        if(ph === '1') In = Pw / (V * PF * EFF);
        else In = Pw / (Math.sqrt(3) * V * PF * EFF);
        const m = parseFloat(sf) >= 1.15 ? 1.25 : 1.15;
        return { n: In.toFixed(2), m: (In * m).toFixed(2) };
    },

    // 8. Caída DC
    calcDropDC: ({ v, i, d, s }) => {
        const V=parseFloat(v), I=parseFloat(i), L=parseFloat(d), S=parseFloat(s);
        if(!V||!I||!L||!S) return null;
        const vd=(2*L*I*0.018)/S;
        return { v: vd.toFixed(2), p: ((vd/V)*100).toFixed(2) };
    },

    // 9. Baterías
    calcBatteryBackup: ({ w, v, ah, eff, dod }) => {
        const W=parseFloat(w), V=parseFloat(v), Ah=parseFloat(ah);
        if(!W) return null;
        const h=(V*Ah*parseFloat(dod))/(W/parseFloat(eff));
        return h.toFixed(1);
    },
    
    // 10. Llenado Ductos
    calcConduitFill: ({ c, w }) => {
        const max = Math.floor((CONDUIT_FILL_DATA.conduit[c] * 0.35) / CONDUIT_FILL_DATA.cable[w]);
        return max;
    },

    // 11. Conversor
    calcUnitConverter: ({ t, v }) => {
        const val = parseFloat(v);
        if(isNaN(val)) return null;
        if(t === 'len') return `${(val * 3.28084).toFixed(2)} ft`;
        if(t === 'temp') return `${((val * 9/5) + 32).toFixed(1)} °F`;
        if(t === 'power') return `${(val * 0.7457).toFixed(2)} kW`;
        return '';
    }
};